<section class="section-container d-flex flex-column flex-md-row">
  <div class="order-1 col-12 offset-md-1 col-md-7">
    <div class="card">
      <ng-container *ngIf="ticketProducts$ | async as groups; else loading">
        <div *ngFor="let group of groups" class="mb-5">
          <h2 class="text-lg text-md-xl mb-4">{{ group.title }}</h2>

          <div
            class="row list-item"
            [class.list-item-contained]="hasItemsWithin(item.product.id, item.supplements) | async"
            *ngFor="let item of group.items"
          >
            <div class="col-7 col-md-8">
              <div class="d-flex">
                <div class="img-thumbnail" *ngIf="item.product.image">
                  <img
                    width="56"
                    height="56"
                    [ngSrc]="item.product.image | plysResize: 56:56"
                    [alt]="item.product.name"
                  />
                </div>
                <div>
                  <h3>
                    <span class="mr-2">{{ item.product.name }}</span>
                    <a
                      [href]="url"
                      target="_blank"
                      *ngIf="
                        isMenuVisible(item.product, item.supplements) && showState.showMenuRedirectUrl$ | async as url
                      "
                      class="menu desktop"
                    >
                      <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>

                      {{ 'global.menu' | transloco }}
                    </a>
                  </h3>
                  <div>
                    <small *ngIf="item.product.priceBefore" class="price-discounted pr-2">{{
                      item.product.priceBefore | localeCurrency: item.product.currency
                    }}</small>
                    <strong class="text-md pr-2">{{
                      item.product.price | localeCurrency: item.product.currency
                    }}</strong>

                    <ng-container
                      *ngTemplateOutlet="
                        productDescription;
                        context: { description: item.product.description, id: item.product.id, extraClass: 'desktop' }
                      "
                    ></ng-container>
                  </div>
                </div>
              </div>
              <ng-container
                *ngTemplateOutlet="
                  productDescription;
                  context: {
                    description: item.product.description,
                    id: item.product.id,
                    extraClass: 'mobile'
                  }
                "
              ></ng-container>
            </div>
            <div class="col-5 col-md-4 mt-3 quantity-control-container">
              <!-- Nothing left and nothing taken yet: the label stands in for the counter entirely. -->
              <div class="sold-out-row" *ngIf="item.availabilityState === 'sold-out'; else quantityControl">
                <ng-container *ngTemplateOutlet="mobileMenu; context: { product: item.product }"></ng-container>
                <span class="sold-out-label">{{ 'tickets.sold_out' | transloco }}</span>
              </div>

              <ng-template #quantityControl>
                <plys-quantity-control
                  [value]="getTicketQuantity(item.product.id) | async"
                  (increased)="addTicketToCart(item.product)"
                  (decreased)="removeTicketFromCart(item.product.id)"
                  [disabled]="item.availabilityState === 'limit-reached'"
                  [useLoading]="true"
                  [displayLoading]="reserving$ | async"
                >
                  <ng-container *ngTemplateOutlet="mobileMenu; context: { product: item.product }"></ng-container>
                </plys-quantity-control>
                <!-- Below the counter, never beside it, so it cannot land on top of the − button. -->
                <small class="sold-out-label sold-out-label-below" *ngIf="item.availabilityState === 'limit-reached'">
                  {{ 'tickets.sold_out' | transloco }}
                </small>
              </ng-template>
            </div>

            <div *ngIf="hasItemsWithin(item.product.id, item.supplements) | async" class="col-12 combi">
              <small class="d-block mb-2">{{ 'tickets.improve_experience' | transloco }}</small>
              <div *ngFor="let supplement of item.supplements" class="combi-item w-100">
                <div class="row no-gutters w-100 no-wrap">
                  <div class="d-flex">
                    <div class="img-thumbnail" *ngIf="supplement.image">
                      <img
                        width="56"
                        height="56"
                        [ngSrc]="supplement.image | plysResize: 56:56"
                        [alt]="supplement.name"
                      />
                    </div>
                    <div>
                      <h6 class="text-sm mb-1 mr-2">
                        {{ supplement.name }}
                        <a
                          [href]="url"
                          target="_blank"
                          *ngIf="isMenuVisible(supplement) && showState.showMenuRedirectUrl$ | async as url"
                          class="menu desktop"
                        >
                          <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>
                          {{ 'global.menu' | transloco }}
                        </a>
                      </h6>
                      <div class="d-flex align-items-center">
                        <strong class="text-base pr-1"
                          >+ {{ supplement.price | localeCurrency: supplement.currency }}</strong
                        >
                        <small class="text-xs color-small">{{ 'tickets.per_ticket' | transloco }}</small>
                      </div>
                      <ng-container
                        *ngTemplateOutlet="
                          productDescription;
                          context: {
                            description: supplement.description,
                            id: item.product.id,
                            childId: supplement.id,
                            extraClass: 'desktop'
                          }
                        "
                      ></ng-container>
                    </div>
                  </div>
                  <div class="combi-quantity mt-3 quantity-control-container">
                    <plys-quantity-control
                      size="sm"
                      [min]="1"
                      [max]="getItemMaxQuantity(supplement) | async"
                      [value]="getSupplementQuantity(supplement.id, item.product.id) | async"
                      (increased)="addItemToCart(supplement, item.supplements, item.product.id)"
                      (decreased)="removeItemFromCart(supplement.id)"
                      [displayLoading]="reserving$ | async"
                    >
                      <a
                        [href]="url"
                        target="_blank"
                        *ngIf="isMenuVisible(supplement) && showState.showMenuRedirectUrl$ | async as url"
                        class="menu mobile-flex"
                      >
                        <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>
                      </a>
                    </plys-quantity-control>
                  </div>
                </div>

                <ng-container
                  *ngTemplateOutlet="
                    productDescription;
                    context: {
                      description: supplement.description,
                      id: item.product.id,
                      childId: supplement.id,
                      extraClass: 'mobile'
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #loading>
        <div class="d-flex justify-content-center align-items-center m-5">
          <mat-spinner class="spinner-primary" [diameter]="30"></mat-spinner>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="order-0 col-12 order-md-1 col-md-3">
    <plys-movie-widget></plys-movie-widget>
    <div class="d-none d-md-block">
      <plys-cart-preview></plys-cart-preview>
    </div>
  </div>
</section>
<footer class="footer d-none d-md-flex justify-content-end">
  <div class="d-flex align-items-center footer-action-right">
    <button class="btn btn-primary btn-lg" (click)="handleContinueClick()" [disabled]="disabledButton$ | async">
      {{ 'global.continue' | transloco }}
    </button>
  </div>
</footer>
<plys-mobile-cart-footer>
  <button
    cartFooterContinue
    class="btn btn-primary btn-lg"
    (click)="handleContinueClick()"
    [disabled]="disabledButton$ | async"
  >
    {{ 'global.continue' | transloco }}
  </button>
</plys-mobile-cart-footer>
<ng-template #mobileMenu let-product="product">
  <a
    [href]="url"
    target="_blank"
    *ngIf="isMenuVisible(product) && showState.showMenuRedirectUrl$ | async as url"
    class="menu mobile-flex"
  >
    <span class="meal-icon" inlineSVG="/assets/icons/meal.svg"></span>
  </a>
</ng-template>
<ng-template
  #productDescription
  let-description="description"
  let-id="id"
  let-childId="childId"
  let-extraClass="extraClass"
>
  <div class="description" [ngClass]="extraClass" *ngIf="isExpanded(id, childId)">
    {{ description }}
  </div>
  <p *ngIf="description" class="read-details" [ngClass]="extraClass" (click)="toggleDetails(id, childId)">
    {{ 'global.read_details' | transloco }}
    <span
      [class.expanded]="isExpanded(id, childId)"
      class="read-details-icon"
      [inlineSVG]="'/assets/icons/icon-chevron-down-thick.svg'"
    ></span>
  </p>
</ng-template>
